<div class="layout-topbar">
  <div class="flex items-center">
    <button class="p-link layout-menu-button layout-topbar-button mr-4" (click)="layoutService.toggleSidebar()">
      <i class="pi pi-bars"></i>
    </button>

    <a class="layout-topbar-logo" [routerLink]="['/']" routerLinkActive="active">
      <img [src]="'assets/images/logo-hubix-platform.svg'" alt="logo" />
    </a>
  </div>

  <div class="flex items-center">
    <app-main-menu></app-main-menu>
    <p-button (onClick)="this.authService.logout()" styleClass="p-button-secondary" label="Logout"></p-button>
  </div>
</div>